import content from './content/terms-and-conditions.json';

export const termsAndConditionsMock = {
  name: 'terms-and-conditions',
  layoutType: 1,
  areasList: [
    {
      id: 'terms-and-conditions-main',
      componentName: 'Comp:TermsAndConditionsPage',
      content: JSON.stringify(content)
    }
  ]
};
